import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.scss";
interface MenuItem {
  key: string;
  label: string;
  icon: string;
  children?: { key: string; label: string }[];
}

const MENU: MenuItem[] = [
  {
    key: "user-group",
    label: "회원 관리",
    icon: "👥",
    children: [
      { key: "user-list", label: "사용자 목록" },
      { key: "certificate-list", label: "자격증 승인" },
      { key: "brand-list", label: "파트너 관리" },
    ],
  },
  {
    key: "order-group",
    label: "주문 관리",
    icon: "🛒",
    children: [
      { key: "order-management", label: "제품 주문 목록" },
      { key: "ticket-purchase-list", label: "수강권 주문 목록" },
      { key: "travel-order-management", label: "투어 주문 목록" },
      { key: "naver-order-register", label: "네이버 주문 등록" },
    ],
  },
  {
    key: "schedule-group",
    label: "스케줄",
    icon: "📅",
    children: [
      { key: "instructor-schedule-list", label: "강습 일정" },
      { key: "practice-schedule-list", label: "연습반 일정" },
      { key: "lesson-request-list", label: "강습 요청" },
    ],
  },
  {
    key: "product-group",
    label: "상품",
    icon: "🛍️",
    children: [
      { key: "product-list", label: "상품 목록" },
      { key: "category-management", label: "카테고리 목록" },
      { key: "policy-management", label: "정책 관리" },
      { key: "review-management", label: "리뷰 관리" },
    ],
  },
  {
    key: "tour-group",
    label: "투어",
    icon: "✈️",
    children: [
      { key: "tour-approval", label: "투어 승인" },
      { key: "tour-management", label: "투어 관리" },
      { key: "tour-refund-policy", label: "환불규정" },
    ],
  },
  {
    key: "category-group",
    label: "수강권",
    icon: "🎫",
    children: [
      { key: "class-list", label: "수강권 목록" },
      { key: "association-list", label: "협회 관리" },
    ],
  },
  {
    key: "settlement-group",
    label: "정산",
    icon: "💰",
    children: [
      { key: "practice-settlement", label: "연습 정산" },
      { key: "settlement-settings", label: "정산 설정" },
    ],
  },
  {
    key: "community-group",
    label: "커뮤니티",
    icon: "🌐",
    children: [
      { key: "report-list", label: "신고글" },
      { key: "board-management", label: "게시판 관리" },
    ],
  },
  {
    key: "statistics-group",
    label: "통계",
    icon: "📊",
    children: [{ key: "bucketlist-stats", label: "버킷리스트" }],
  },
  {
    key: "marketing-group",
    label: "CMS",
    icon: "📣",
    children: [
      { key: "home-screen-setting", label: "홈화면 설정" },
      { key: "popup-management", label: "팝업 관리" },
      { key: "announcement", label: "공지사항" },
    ],
  },
  // { key: "admin-management", label: "계정 관리", icon: "🔑" },
];

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPage = location.pathname.replace(/^\//, "").split("/")[0];

  const [openGroups, setOpenGroups] = useState<Set<string>>(() => {
    const initial = new Set<string>();
    MENU.forEach((m) => {
      if (m.children?.some((c) => c.key === currentPage)) initial.add(m.key);
    });
    return initial;
  });

  const toggleGroup = (key: string) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const isActive = (key: string) => key === currentPage;

  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <span className="sidebar__logo-icon"></span>
        <div>
          <div className="sidebar__logo-title">BUCKETLIST CLASS</div>
          <div className="sidebar__logo-sub">admin</div>
        </div>
      </div>

      <nav className="sidebar__nav">
        {MENU.map((item) => {
          if (!item.children) {
            return (
              <button
                key={item.key}
                className={`sidebar__item ${isActive(item.key) ? "sidebar__item--active" : ""}`}
                onClick={() => navigate(`/${item.key}`)}
              >
                <span className="sidebar__icon">{item.icon}</span>
                <span className="sidebar__label">{item.label}</span>
              </button>
            );
          }

          const isOpen = openGroups.has(item.key);
          const hasActive = item.children.some((c) => isActive(c.key));

          return (
            <div key={item.key}>
              <button
                className={`sidebar__item sidebar__item--group ${hasActive ? "sidebar__item--has-active" : ""}`}
                onClick={() => toggleGroup(item.key)}
              >
                <span className="sidebar__icon">{item.icon}</span>
                <span className="sidebar__label">{item.label}</span>
                <span className={`sidebar__arrow ${isOpen ? "sidebar__arrow--open" : ""}`}>›</span>
              </button>
              {isOpen && (
                <div className="sidebar__sub">
                  {item.children.map((child) => (
                    <button
                      key={child.key}
                      className={`sidebar__sub-item ${isActive(child.key) ? "sidebar__sub-item--active" : ""}`}
                      onClick={() => navigate(`/${child.key}`)}
                    >
                      {child.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className="sidebar__footer">
        <div className="sidebar__user">
          <div className="sidebar__avatar">A</div>
          <div>
            <div className="sidebar__user-name">admin@buccl.com</div>
            <div className="sidebar__user-role">Super Admin</div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
